export class StringUtils {
    static composeAddress (addressComponents: Array<string | null>): string {
        return addressComponents.filter((component: string| null) => !!component).join(', ')
    }

    static stringToHtmlElement (value: string) {
        const parser = new DOMParser()
        const content = 'text/html'
        const DOM = parser.parseFromString(value, content)
        return DOM.body.childNodes[0]
    }

    static trimString (stringToTrim: string | null): string | null {
        // trims every whitespace from string
        return stringToTrim ? stringToTrim.replace(/\s/g, '') : stringToTrim
    }
}
